import roles from '@/utils/roles'

export default {
    path: '/manage/ai/',
    display: 'Manage AI',
    name: 'manage-ai-home',
    component: () => import(/* webpackChunkName: "manageAi" */ './ManageAiHome.vue'),
    meta: {
        layout: 'app',
        roles: [roles.admin, roles.aiAdmin, roles.research, roles.salesAdmin],
    },
    children: [
        {
            path: 'skillset-match',
            name: 'manage-ai-skillset-match-home',
            display: 'Skillset Match',
            component: () => import(/* webpackChunkName: "manageAi" */ './SkillsetMatch/ManageAiSkillsetMatchHome.vue'),
            meta: {
                roles: [roles.admin, roles.aiAdmin, roles.research, roles.salesAdmin],
            },
        },
        {
            path: 'transcripts/topics',
            name: 'manage-ai-transcripts-topics',
            display: 'Transcript Topics',
            component: () =>
                import(/* webpackChunkName: "manageAi" */ './Transcripts/Topics/ManageTranscriptTopicsPage.vue'),
            meta: {
                roles: [roles.admin, roles.aiAdmin],
            },
        },
    ],
}
